<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" *ngIf='displayState.workingDiv'>
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
        <div class="row">
            <div class="col-md-10 offset-1">
                        <p-table #cns [columns]="cols" [value]="caseList" [responsive]="true" [scrollable]="true" scrollHeight="230px" [(selection)]="selectedCases" dataKey="applicationId" >
                            <ng-template pTemplate="caption">
                                <div class="ui-table-globalfilter-container">
                                    <input type="text" pInputText size="30" [(ngModel)]="filterOptions.casesNeedSched" placeholder="Global Filter" title="Enter text for which to search" (input)="cns.filterGlobal($event.target.value, 'contains')" style="width:200px;">
                                </div>
                                &nbsp;&nbsp;&nbsp;
                                <label>Cases Needing Scheduling</label>
                            </ng-template>
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th style="width: 3%;">
                                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th [pSortableColumn]="'caseNum'" style="width: 7%;">{{ cols[0].header }} <p-sortIcon [field]="'caseNum'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'applicantName'" style="width: 20%;">{{ cols[1].header }} <p-sortIcon [field]="'applicantName'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'propType'" style="width: 25%;">{{ cols[2].header }} <p-sortIcon [field]="'propType'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'city'" style="width: 10%;">{{ cols[3].header }} <p-sortIcon [field]="'city'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'totalValue'" style="width: 10%;">{{ cols[4].header }} <p-sortIcon [field]="'totalValue'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'valueDifference'" style="width: 10%;">{{ cols[5].header }} <p-sortIcon [field]="'valueDifference'"></p-sortIcon></th>
                                    <th [pSortableColumn]="'status'" style="width: 15%;">{{ cols[6].header }} <p-sortIcon [field]="'status'"></p-sortIcon></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-case>
                                <tr [pSelectableRow]="case">
                                    <td style="width: 3%;">
                                        <p-tableCheckbox [value]="case"></p-tableCheckbox>
                                    </td>
                                    <td style="width: 7%;">{{ case.caseNum }}</td>
                                    <td style="width: 20%;">{{ case.applicantName }}</td>
                                    <td style="width: 25%;">{{ case.propType }}</td>
                                    <td style="width: 10%;">{{ case.city }}</td>
                                    <td style="width: 10%;">{{ case.totalValue | number }}</td>
                                    <td style="width: 10%;">{{ case.valueDifference | number }}</td>
                                    <td style="width: 15%;">{{ case.status }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="row" >
                                    <div class="col-md-2 offset-1" style="text-align: left;"># of cases: {{ caseList?.length }}</div>
                                    <div class="col-md-3 offset-1" style="text-align: left;"># of selected cases: {{ +selectedCases?.length }}</div>
                                </div>
                            </ng-template>
                        </p-table>

            </div>
        </div>
        <br />
        <div class="row" style="padding-bottom: 10px;">
            <div class="col-md-3 offset-1">
                <label for="schedDate" style="padding-right: 10px;"><strong>Hearing Date:</strong></label>
                <select id="schedDate" style="width: 180px;" title="Select a date" [(ngModel)]="scheduleDate" class="form form-input" (change)="selectDate($event)">
                    <option value=""></option>
                    <!-- <option *ngFor="let opt of schedDateList" [ngValue]="opt.id">{{opt.hearingDate | date:"MM/dd/yyyy"}}</option> -->
                  <option *ngFor="let opt of schedDateList" [ngValue]="opt.id">{{opt.hearingDateDesc}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <button title="Click this button after selecting desired case(s), from list ABOVE, and a Hearing Date (at LEFT)" type="submit" class="btn btn-success btn-sm" [disabled]="selectedCases?.length<1 || !scheduleDate" (click)="scheduleCases()">Schedule Selected Cases</button>
            </div>
            <div class="col-md-3">
                <label for="moveToDate" style="padding-right: 10px;"><strong>Move Case(s) to Hearing Date:</strong></label>
                <select id="moveToDate" style="width: 180px;" title="Select target Hearing Date" [(ngModel)]="moveToDate" class="form form-input" [disabled]="selectedHearingCases?.length<1">
                    <option value=""></option>
                    <!-- <option *ngFor="let opt of schedDateList" [ngValue]="opt.id">{{opt.hearingDate | date:"MM/dd/yyyy"}}</option> -->
                  <option *ngFor="let opt of schedDateList" [ngValue]="opt.id">{{opt.hearingDateDesc}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <button title="Click this button after selecting desired case(s), from list BELOW, and a Hearing Date (from list at LEFT)" type="submit" class="btn btn-success btn-sm" [disabled]="selectedHearingCases?.length<1 || !moveToDate" (click)="moveCases()">Move Selected Cases</button>
            </div>

        </div>
        <div class="row" *ngIf="scheduleDate">
            <div class="col-md-10 offset-1">
                        <p-table #sc [columns]="schedCaseCols" [value]="schedCaseList" [scrollable]="true" [(selection)]="selectedHearingCases" scrollHeight="185px">
                            <ng-template pTemplate="caption">

                                <div class="ui-table-globalfilter-container">
                                    <input type="text" pInputText size="40" [(ngModel)]="filterOptions.casesOnDate" placeholder="Global Filter" (change)="sc.filterGlobal($event.target.value, 'contains')" style="width:200px;">
                                </div>
                                &nbsp;&nbsp;&nbsp;
                                <label>Cases On Schedule</label>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 50px;">
                                        <!--<p-tableHeaderCheckbox></p-tableHeaderCheckbox>-->
                                    </th>
                                    <th [pSortableColumn]="'caseNum'">{{ schedCaseCols[0].header }} <p-sortIcon [field]="schedCaseCols[0].field"></p-sortIcon></th>
                                    <th [pSortableColumn]="'applicantName'">{{ schedCaseCols[1].header }} <p-sortIcon [field]="schedCaseCols[1].field"></p-sortIcon></th>
                                    <th [pSortableColumn]="'status'">{{ schedCaseCols[2].header }} <p-sortIcon [field]="schedCaseCols[2].field"></p-sortIcon></th>
                                    <!--<th *ngFor="let col of schedCaseCols">
                                        {{col.header}}
                                    </th>-->
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-case>
                                <tr [pSelectableRow]="case">
                                    <td style="width: 50px;">
                                        <p-tableCheckbox [value]="case" *ngIf="!case.status.startsWith('Noticed')" [disabled]="case.status.startsWith('Noticed')"></p-tableCheckbox>
                                    </td>
                                    <td>{{ case.caseNum }}</td>
                                    <td>{{ case.applicantName }}</td>
                                    <td>{{ case.status }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="row">
                                    <div class="col-md-2 offset-1" style="text-align: left;"># of cases: {{ schedCaseList?.length }}</div>
                                    <div class="col-md-5 offset-1" style="text-align: left;"># of cases to be moved: {{ +selectedHearingCases?.length }}</div>
                                </div>

                            </ng-template>
                        </p-table>
            </div>
        </div>
